import { initialize, LDClient, LDUser } from 'launchdarkly-js-client-sdk';
import configs from '../../constants/configs';

// Lazy initialize. If no flags requested, no need to connect to LD.
let clientSingleton: LDClient;

export function initializeClient(user: LDUser) {
    if (!clientSingleton) {
        clientSingleton = initialize(configs.launchDarkly, user);
    }
}

export function getClient() {
    return clientSingleton;
}
